import { Breadcrumbs, type BreadcrumbsProps, styled } from "@mui/material";
import type { FC } from "react";

export const BreadcrumbsContainer: FC<BreadcrumbsProps> = styled(Breadcrumbs)(
  ({ theme }) => ({
    color: theme.palette.text.primary,
  }),
);
